import { ApolloLink } from '@apollo/client';
import { token } from '@trello/session-cookie';

// eslint-disable-next-line @trello/no-module-logic
export const trelloRequiredHeadersLink = new ApolloLink(
  (operation, forward) => {
    const context = operation.getContext();
    operation.setContext(() => ({
      headers: {
        ...(context.headers || {}),
        'X-Trello-Client-Version': context.clientAwareness?.version || 'dev-0',
        // The value of the XSRF token is currently the same as the auth token, but will probably eventually become a
        // short-lived XSRF token.
        'X-Trello-XSRF-Token': token,
      },
    }));

    return forward(operation);
  },
);
